import script from "./MemberAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./MemberAvatar.vue?vue&type=style&index=0&id=58827ccf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58827ccf"]])

export default __exports__